module.exports = __webpack_public_path__ + "static/media/SmartNewLoadingGray.d818caad.svg";